import { europeanCountries } from 'core/user/entities';

export const countriesWithVAT = [...europeanCountries];
